import { memo, PropsWithChildren } from 'react';

import { If } from 'shared';
import { Column, Row, Typography } from 'shared/Houston';

import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

import { Paper, ContainerAction } from './styles';

interface IProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  action?: React.ReactNode;
  disablePaddingBottom?: boolean;
}

const CardForm: React.FC<PropsWithChildren<IProps>> = ({ title, subtitle, action, children, disablePaddingBottom }) => {
  const theme = useHoustonTheme();

  const padding = disablePaddingBottom ? `${theme.spacing.xxxs} ${theme.spacing.xxxs} 0` : theme.spacing.xxxs;

  return (
    <Paper paper xs={{ padding, margin: `${theme.spacing.xxxs} 0` }}>
      <Row alignItems='center' justifyContent='space-between'>
        <Column>
          <If condition={title}>
            <Typography size='md' weight='semibold' marginBottom color='neutralColor.low.dark'>
              {title}
            </Typography>
          </If>
          <If condition={!!subtitle}>
            <Typography size='xxs' marginBottom color='neutralColor.low.dark'>
              {subtitle}
            </Typography>
          </If>
        </Column>
        <If condition={!!action}>
          <ContainerAction>{action}</ContainerAction>
        </If>
      </Row>

      {children}
    </Paper>
  );
};

export default memo(CardForm);
